import {
  toTurnMessagePayload,
  type UnmaskedTurnMessage,
} from './shared-responder-v2-gateway-turn-message.mapper';
import type { QuestionTurnPayload } from './shared-responder-v2-gateway-turn.helpers';

export interface TurnFragmentPayload<TMessageFragment, TQuestionFragment> {
  readonly isQuestionComplete: boolean;
  readonly isConversationOver: boolean;
  readonly surveyProgress: number;
  readonly sent?: TMessageFragment | null;
  readonly replyFeedback?: TMessageFragment | null;
  readonly reply?: TMessageFragment | null;
  readonly nextQuestion?: TQuestionFragment | null;
  readonly thankYouMessage?: TMessageFragment | null;
  readonly actions?: QuestionTurnPayload['actions'];
}

export function toTurnPayloadFromFragments<TMessageFragment, TQuestionFragment>(
  turn: TurnFragmentPayload<TMessageFragment, TQuestionFragment>,
  unmaskMessage: (message: TMessageFragment) => UnmaskedTurnMessage,
  unmaskQuestion: (question: TQuestionFragment) => {
    readonly id: string;
    readonly required?: boolean | null;
  }
): QuestionTurnPayload {
  function toMessagePayload(
    message: TMessageFragment | null | undefined
  ): QuestionTurnPayload['sent'] {
    return toTurnMessagePayload(
      message == null ? null : unmaskMessage(message)
    );
  }

  const nextQuestion =
    turn.nextQuestion == null ? null : unmaskQuestion(turn.nextQuestion);
  const thankYouMessage =
    turn.thankYouMessage == null ? null : unmaskMessage(turn.thankYouMessage);

  return {
    isQuestionComplete: turn.isQuestionComplete,
    isConversationOver: turn.isConversationOver,
    surveyProgress: turn.surveyProgress,
    sent: toMessagePayload(turn.sent),
    replyFeedback: toMessagePayload(turn.replyFeedback),
    reply: toMessagePayload(turn.reply),
    nextQuestion:
      nextQuestion === null
        ? null
        : { id: nextQuestion.id, required: nextQuestion.required },
    thankYouMessage:
      thankYouMessage === null ? null : { text: thankYouMessage.text },
    actions: turn.actions,
  };
}
